import { Card, CardContent, Typography, Box } from '@mui/material';
import type { SxProps } from '@mui/material';

interface StatCardProps {
  label: string;
  value: string;
  subtitle?: string;
  icon?: React.ReactNode;
  color?: string;
  sx?: SxProps;
}

export function StatCard({ label, value, subtitle, icon, color, sx }: StatCardProps) {
  return (
    <Card sx={sx}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
          <Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>{label}</Typography>
            <Typography variant="h5" sx={{ fontWeight: 700, color: color || 'text.primary' }}>{value}</Typography>
            {subtitle && <Typography variant="caption" color="text.secondary">{subtitle}</Typography>}
          </Box>
          {icon && (
            <Box sx={{ color: color || 'primary.main', opacity: 0.8 }}>{icon}</Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
}
